import SchoolTermApi from '../../../api/src/basic/api/SchoolTermApi'
import {message} from "ant-design-vue";

const schoolTermApi = new SchoolTermApi();

const state = {
    majorList: []
}

const mutations = {
    addMajorList(state, data) {
        state.majorList = data || []
    },
}

const actions = {
    // 分页查询学期
    pageSchoolTerm: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            schoolTermApi.page(query.pageNum).then(res=>{
                resolve(res)
            }).catch(err=>{
                message.error(err.message)
                reject(err)
            })
        })
    },
    // 新增学期
    addSchoolTerm: ({commit, state}, query) => {
        console.log(query)
        return new Promise((resolve, reject) => {
            schoolTermApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 删除管理员
    delSchoolTerm: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            schoolTermApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 修改学期
    editSchoolTerm: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            schoolTermApi.update(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                this.$message.error(err.message)
                console.log(err)
            })
        })
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}